import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
const UpdatesV2Provider = (props) => {
  const api = new API();
  const [UPDATESV2SpecilityFilter, setUPDATESV2SpecilityFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [UPDATESV2SpecilityList, setUPDATESV2SpecilityList] = useState([]);
  const [UPDATESV2SpecilityLoader, setUPDATESV2SpecilityLoader] = useState(false);
  const [UPDATESV2TopicFilter, setUPDATESV2TopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [UPDATESV2TopicList, setUPDATESV2TopicList] = useState([]);
  const [UPDATESV2TopicLoader, setUPDATESV2TopicLoader] = useState(false);
  const [UPDATESV2SubTopicFilter, setUPDATESV2SubTopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [UPDATESV2SubTopicList, setUPDATESV2SubTopicList] = useState([]);
  const [UPDATESV2SubTopicLoader, setUPDATESV2SubTopicLoader] = useState(false);
  const [UPDATESV2UPDATESFilter, setUPDATESV2UPDATESFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [UPDATESV2UPDATESList, setUPDATESV2UPDATESList] = useState([]);
  const [UPDATESV2UPDATESLoader, setUPDATESV2UPDATESLoader] = useState(false);

  const fetchUPDATESV2Specility = async () => {
    setUPDATESV2SpecilityLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("updates/updates_speciality_list_v2", { ...UPDATESV2SpecilityFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setUPDATESV2SpecilityList(res?.data?.data);
          setUPDATESV2SpecilityLoader(false);
        } else {
          setUPDATESV2SpecilityList([]);
          setUPDATESV2SpecilityLoader(false);
        }
      });
  }

  const fetchUPDATESV2Topic = async (subcategory_id=null) => {
    if(!subcategory_id) return;
    setUPDATESV2TopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("updates/updates_topic_list_v2", { ...UPDATESV2TopicFilter, subcategory_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setUPDATESV2TopicList(res?.data?.data);
          setUPDATESV2TopicLoader(false);
        } else {
          setUPDATESV2TopicList([]);
          setUPDATESV2TopicLoader(false);
        }
      });
  }

  const fetchUPDATESV2SubTopic = async (subject_id=null) => {
    if(!subject_id) return;
    setUPDATESV2SubTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("updates/updates_subtopic_list_v2", { ...UPDATESV2SubTopicFilter, subject_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setUPDATESV2SubTopicList(res?.data?.data);
          setUPDATESV2SubTopicLoader(false);
        } else {
          setUPDATESV2SubTopicList([]);
          setUPDATESV2SubTopicLoader(false);
        }
      });
  }

  const fetchUPDATESV2UPDATES = async (topic_id=null) => {
    if(!topic_id) return;
    setUPDATESV2UPDATESLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("updates/updates_notes_list_v2", { ...UPDATESV2UPDATESFilter, topic_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setUPDATESV2UPDATESList(res?.data?.data);
          setUPDATESV2UPDATESLoader(false);
        } else {
          setUPDATESV2UPDATESList([]);
          setUPDATESV2UPDATESLoader(false);
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        UPDATESV2SpecilityFilter, setUPDATESV2SpecilityFilter,
        UPDATESV2SpecilityList, setUPDATESV2SpecilityList,
        UPDATESV2SpecilityLoader, setUPDATESV2SpecilityLoader,
        fetchUPDATESV2Specility,
        UPDATESV2TopicFilter, setUPDATESV2TopicFilter,
        UPDATESV2TopicList, setUPDATESV2TopicList,
        UPDATESV2TopicLoader, setUPDATESV2TopicLoader,
        fetchUPDATESV2Topic,
        UPDATESV2SubTopicFilter, setUPDATESV2SubTopicFilter,
        UPDATESV2SubTopicList, setUPDATESV2SubTopicList,
        UPDATESV2SubTopicLoader, setUPDATESV2SubTopicLoader,
        fetchUPDATESV2SubTopic,
        UPDATESV2UPDATESFilter, setUPDATESV2UPDATESFilter,
        UPDATESV2UPDATESList, setUPDATESV2UPDATESList,
        UPDATESV2UPDATESLoader, setUPDATESV2UPDATESLoader,
        fetchUPDATESV2UPDATES,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default UpdatesV2Provider;
